/** Volto Project Configuration */
import '@plone/volto/config';
import blocksConfig from './config/blocks';
import LuogoView from './components/Views/LuogoView';
import LuogoEdit from './components/Edit/LuogoEdit';
import { ColorPickerWidget } from '@plone/volto/components/manage/Widgets';
import set from 'lodash/set';
import BandoView from './components/Views/BandoView';
import NewsTemplate from './customizations/volto/components/manage/Blocks/Listing/NewsTemplate';
import SimpleCardTemplate from './customizations/volto/components/manage/Blocks/Listing/SimpleCardTemplate';
import ImageCardTemplate from './customizations/volto/components/manage/Blocks/Listing/ImageCardTemplate';
import AllegatiTemplate from './customizations/volto/components/manage/Blocks/Listing/AllegatiTemplate';
import AllegatiListaTemplate from './customizations/volto/components/manage/Blocks/Listing/AllegatiListaTemplate';
import LinkToImageTemplate from './customizations/volto/components/manage/Blocks/Listing/LinkToImageTemplate';
import MappaTemplate from './customizations/volto/components/manage/Blocks/Listing/MappaTemplate';
import BandiCardTemplate from 'customizations/volto/components/manage/Blocks/Listing/BandiCardTemplate';
import PageView from './customizations/volto/components/theme/View/PageView';
import voltoGdprPrivacy from 'volto-gdpr-privacy';
import voltoSocialSettings from 'volto-social-settings';
import { GeoLocationWidget } from 'volto-venue';
import slateConfig from './customizations/slate/slateConfig';

// Estende lo schema del blocco Listing solo per image_card
const imageCardSchemaEnhancer = ({ schema, formData, intl }) => {
  return {
    ...schema,
    fieldsets: [
      ...schema.fieldsets,
      {
        id: 'card_settings',
        title: intl.formatMessage({ id: 'Impostazioni Card', defaultMessage: 'Stile' }),
        fields: ['showFourColums', 'showReadMore', 'readMoreText', 'cardBackground', 'showPublishDate'],
      },
      {
        id: 'link_settings',
        title: intl.formatMessage({ id: 'LINK AD ALTRO', defaultMessage: 'LINK AD ALTRO' }),
        fields: ['linkText', 'linkUrl', 'alignButtonRight'],
      },
    ],
    properties: {
      ...schema.properties,
      showFourColums: {
        title: intl.formatMessage({
          id: 'Visualizza a 4 colonne',
          defaultMessage: 'Visualizza a 4 colonne'
        }),
        type: 'boolean',
        default: false,
      },
      showPublishDate: {
        title: intl.formatMessage({
          id: 'Visualizza data di pubblicazione',
          defaultMessage: 'Visualizza data di pubblicazione'
        }),
        type: 'boolean',
        default: false,
      },
      showReadMore: {
        title: intl.formatMessage({
          id: 'Visualizza link di approfondimento',
          defaultMessage: 'Visualizza link di approfondimento'
        }),
        type: 'boolean',
        default: false,
      },
      readMoreText: {
        title: intl.formatMessage({
          id: 'Testo del link "Vedi tutto"',
          defaultMessage: 'Read more link text'
        }),
        description: intl.formatMessage({
          id: 'Testo personalizzato per il link "Vedi tutto"',
          defaultMessage: 'Custom text for the "Read more" link'
        }),
        default: 'Vedi tutto',
      },
      cardBackground: {
        title: intl.formatMessage({ id: 'Sfondo', defaultMessage: 'Background' }),
        description: intl.formatMessage({
          id: 'Scegli il colore di sfondo per il blocco',
          defaultMessage: 'Scegli il colore di sfondo per il blocco'
        }),
        choices: [
          ['no-background', intl.formatMessage({ id: 'Nessuno sfondo', defaultMessage: 'No background' })],
          ['blue-background', intl.formatMessage({ id: 'Azzurro', defaultMessage: 'Azzurro' })],
          ['pastel-blue-background', intl.formatMessage({ id: 'AzzurroPastello', defaultMessage: 'Azzurro pastello' })],
        ],
        default: 'no-background',
      },
      linkText: {
        title: intl.formatMessage({
          id: 'Testo Link',
          defaultMessage: 'Testo Link'
        }),
        description: intl.formatMessage({
          id: 'Testo da visualizzare per il link',
          defaultMessage: 'Testo da visualizzare per il link'
        }),
        type: 'string',
        default: '',
      },
      linkUrl: {
        title: intl.formatMessage({
          id: 'Link a',
          defaultMessage: 'Link a'
        }),
        description: intl.formatMessage({
          id: 'URL di destinazione del link',
          defaultMessage: 'URL di destinazione del link'
        }),
        type: 'string',
        widget: 'url',
      },
      alignButtonRight: {
        title: intl.formatMessage({
          id: 'Allinea bottone a destra',
          defaultMessage: 'Allinea bottone a destra'
        }),
        type: 'boolean',
        default: false,
      },
    },
  };
};

const listNewsSchemaEnhancer = ({ schema, formData, intl }) => {
  return {
    ...schema,
    fieldsets: [
      ...schema.fieldsets,
      {
        id: 'card_settings',
        title: intl.formatMessage({ id: 'Impostazioni Card', defaultMessage: 'Stile' }),
        fields: ['showReadMore', 'readMoreText', 'cardBackground', 'showPublishDate'],
      },
    ],
    properties: {
      ...schema.properties,

      showPublishDate: {
        title: intl.formatMessage({
          id: 'Visualizza data di pubblicazione',
          defaultMessage: 'Visualizza data di pubblicazione'
        }),
        type: 'boolean',
        default: false,
      },
      showReadMore: {
        title: intl.formatMessage({
          id: 'Visualizza link di approfondimento',
          defaultMessage: 'Visualizza link di approfondimento'
        }),
        type: 'boolean',
        default: false,
      },
      readMoreText: {
        title: intl.formatMessage({
          id: 'Testo del link "Vedi tutto"',
          defaultMessage: 'Read more link text'
        }),
        description: intl.formatMessage({
          id: 'Testo personalizzato per il link "Vedi tutto"',
          defaultMessage: 'Custom text for the "Read more" link'
        }),
        default: 'Vedi tutto',
      },
      cardBackground: {
        title: intl.formatMessage({ id: 'Sfondo', defaultMessage: 'Background' }),
        description: intl.formatMessage({
          id: 'Scegli il colore di sfondo per il blocco',
          defaultMessage: 'Scegli il colore di sfondo per il blocco'
        }),
        choices: [
          ['no-background', intl.formatMessage({ id: 'Nessuno sfondo', defaultMessage: 'No background' })],
          ['blue-background', intl.formatMessage({ id: 'Azzurro', defaultMessage: 'Azzurro' })],
          ['pastel-blue-background', intl.formatMessage({ id: 'AzzurroPastello', defaultMessage: 'Azzurro pastello' })],
        ],
        default: 'no-background',
      },
    },
  };
};

const allegatiSchemaEnhancer = ({ schema, formData, intl }) => {
  return {
    ...schema,
    fieldsets: [
      ...schema.fieldsets,
      {
        id: 'card_settings',
        title: intl.formatMessage({ id: 'Impostazioni Card', defaultMessage: 'Stile' }),
        fields: ['showFourColums', 'cardBackground'],
      },
      {
        id: 'link_settings',
        title: intl.formatMessage({ id: 'LINK AD ALTRO', defaultMessage: 'LINK AD ALTRO' }),
        fields: ['linkText', 'linkUrl', 'alignButtonRight'],
      },
    ],
    properties: {
      ...schema.properties,
      showFourColums: {
        title: intl.formatMessage({
          id: 'Visualizza a 4 colonne',
          defaultMessage: 'Visualizza a 4 colonne'
        }),
        type: 'boolean',
        default: false,
      },
      cardBackground: {
        title: intl.formatMessage({ id: 'Sfondo', defaultMessage: 'Background' }),
        description: intl.formatMessage({
          id: 'Scegli il colore di sfondo per il blocco',
          defaultMessage: 'Scegli il colore di sfondo per il blocco'
        }),
        choices: [
          ['no-background', intl.formatMessage({ id: 'Nessuno sfondo', defaultMessage: 'No background' })],
          ['blue-background', intl.formatMessage({ id: 'Azzurro', defaultMessage: 'Azzurro' })],
          ['pastel-blue-background', intl.formatMessage({ id: 'AzzurroPastello', defaultMessage: 'Azzurro pastello' })],
        ],
        default: 'no-background',
      },
      linkText: {
        title: intl.formatMessage({
          id: 'Testo Link',
          defaultMessage: 'Testo Link'
        }),
        description: intl.formatMessage({
          id: 'Testo da visualizzare per il link',
          defaultMessage: 'Testo da visualizzare per il link'
        }),
        type: 'string',
        default: '',
      },
      linkUrl: {
        title: intl.formatMessage({
          id: 'Link a',
          defaultMessage: 'Link a'
        }),
        description: intl.formatMessage({
          id: 'URL di destinazione del link',
          defaultMessage: 'URL di destinazione del link'
        }),
        type: 'string',
        widget: 'url',
      },
      alignButtonRight: {
        title: intl.formatMessage({
          id: 'Allinea bottone a destra',
          defaultMessage: 'Allinea bottone a destra'
        }),
        type: 'boolean',
        default: false,
      },
    },
  };
};

const bandiCardSchemaEnhancer = ({ schema, formData, intl }) => {
  return {
    ...schema,
    fieldsets: [
      ...schema.fieldsets,
      {
        id: 'search_params', // Corretto typo "serach_params"
        title: intl.formatMessage({ id: 'Altri criteri', defaultMessage: 'Altri criteri' }),
        fields: ['filterStatus'],
      },
      {
        id: 'card_settings',
        title: intl.formatMessage({ id: 'Impostazioni Card', defaultMessage: 'Stile' }),
        fields: ['showFourColums', 'showReadMore', 'readMoreText', 'cardBackground', 'cardIcon'],
      },      
      {
        id: 'link_settings',
        title: intl.formatMessage({ id: 'LINK AD ALTRO', defaultMessage: 'LINK AD ALTRO' }),
        fields: ['linkText', 'linkUrl', 'alignButtonRight'],
      },
    ],
    properties: {
      ...schema.properties,
      showFourColums: {
        title: intl.formatMessage({
          id: 'Visualizza a 4 colonne',
          defaultMessage: 'Visualizza a 4 colonne'
        }),
        type: 'boolean',
        default: false,
      },      
      showReadMore: {
        title: intl.formatMessage({
          id: 'Visualizza link di approfondimento',
          defaultMessage: 'Visualizza link di approfondimento'
        }),
        type: 'boolean',
        default: false,
      },
      readMoreText: {
        title: intl.formatMessage({
          id: 'Testo del link "Vedi tutto"',
          defaultMessage: 'Read more link text'
        }),
        description: intl.formatMessage({
          id: 'Testo personalizzato per il link "Vedi tutto"',
          defaultMessage: 'Custom text for the "Read more" link'
        }),
        default: 'Vedi tutto',
      },
      cardBackground: {
        title: intl.formatMessage({ id: 'Sfondo', defaultMessage: 'Background' }),
        description: intl.formatMessage({
          id: 'Scegli il colore di sfondo per il blocco',
          defaultMessage: 'Scegli il colore di sfondo per il blocco'
        }),
        choices: [
          ['no-background', intl.formatMessage({ id: 'Nessuno sfondo', defaultMessage: 'No background' })],
          ['blue-background', intl.formatMessage({ id: 'Azzurro', defaultMessage: 'Azzurro' })],
          ['pastel-blue-background', intl.formatMessage({ id: 'AzzurroPastello', defaultMessage: 'Azzurro pastello' })],
        ],
        default: 'no-background',
      },
      // *** CAMPO CORRETTO PER filterStatus ***
      filterStatus: {
        title: intl.formatMessage({ id: 'Stato', defaultMessage: 'Stato' }),
        description: intl.formatMessage({
          id: 'Scegli lo stato dei bandi da visualizzare',
          defaultMessage: 'Scegli lo stato dei Bandi da visualizzare',
        }),
        type: 'array',
        // Definisci le scelte direttamente nel campo array
        choices: [
          ['status-active', intl.formatMessage({ id: 'Attivo', defaultMessage: 'Attivo' })],
          ['status-scheduled', intl.formatMessage({ id: 'Programmato', defaultMessage: 'Programmato' })],
          ['status-in-progress', intl.formatMessage({ id: 'In corso', defaultMessage: 'In corso' })],
          ['status-closed', intl.formatMessage({ id: 'Chiuso', defaultMessage: 'Chiuso' })],
        ],
        widget: 'array', // Usa widget 'array' invece di 'choices'
        default: [],
      },
      
      // *** ALTERNATIVA: Se il widget 'array' non funziona, prova questo ***
      /*
      filterStatus: {
        title: intl.formatMessage({ id: 'Stato', defaultMessage: 'Stato' }),
        description: intl.formatMessage({
          id: 'Scegli lo stato dei bandi da visualizzare',
          defaultMessage: 'Scegli lo stato dei Bandi da visualizzare',
        }),
        type: 'array',
        choices: [
          ['status-active', intl.formatMessage({ id: 'Attivo', defaultMessage: 'Attivo' })],
          ['status-scheduled', intl.formatMessage({ id: 'Programmato', defaultMessage: 'Programmato' })],
          ['status-in-progress', intl.formatMessage({ id: 'In corso', defaultMessage: 'In corso' })],
          ['status-closed', intl.formatMessage({ id: 'Chiuso', defaultMessage: 'Chiuso' })],
        ],
        widget: 'select',
        multiple: true,
        default: [],
      },
      */
      cardIcon: {
        title: intl.formatMessage({
          id: 'Icona Card',
          defaultMessage: 'Icona Card',
        }),
        description: intl.formatMessage({
          id: 'Seleziona un\'icona per la card',
          defaultMessage: 'Seleziona un\'icona per la card. Inizia a digitare per trovare un icona o consulta: https://fontawesome.com/v6/search'
        }),
        type: 'string',
        widget: 'icon_selector',
        default: '',
      },
      linkText: {
        title: intl.formatMessage({
          id: 'Testo Link',
          defaultMessage: 'Testo Link'
        }),
        description: intl.formatMessage({
          id: 'Testo da visualizzare per il link',
          defaultMessage: 'Testo da visualizzare per il link'
        }),
        type: 'string',
        default: '',
      },
      linkUrl: {
        title: intl.formatMessage({
          id: 'Link a',
          defaultMessage: 'Link a'
        }),
        description: intl.formatMessage({
          id: 'URL di destinazione del link',
          defaultMessage: 'URL di destinazione del link'
        }),
        type: 'string',
        widget: 'url',
      },
      alignButtonRight: {
        title: intl.formatMessage({
          id: 'Allinea bottone a destra',
          defaultMessage: 'Allinea bottone a destra'
        }),
        type: 'boolean',
        default: false,
      },
    },
  };
};


const mappaSchemaEnhancer = ({ schema, formData, intl }) => {
  return {
    ...schema,
    fieldsets: [
      ...schema.fieldsets,
      {
        id: 'card_settings',
        title: intl.formatMessage({ id: 'Impostazioni Card', defaultMessage: 'Stile' }),
        fields: ['cardBackground', 'altezzaMappa'],
      },
      {
        id: 'link_settings',
        title: intl.formatMessage({ id: 'LINK AD ALTRO', defaultMessage: 'LINK AD ALTRO' }),
        fields: ['linkText', 'linkUrl', 'alignButtonRight'],
      },
    ],
    properties: {
      ...schema.properties,

      // Aggiunta filtro di default per "Luogo"
      query: {
        title: intl.formatMessage({ id: 'Criteri di ricerca', defaultMessage: 'Query' }),
        widget: 'querystring',
        default: [
          {
            i: 'portal_type',
            o: 'plone.app.querystring.operation.selection.is',
            v: ['Luogo'],
          },
        ],
      },

      cardBackground: {
        title: intl.formatMessage({ id: 'Sfondo', defaultMessage: 'Background' }),
        description: intl.formatMessage({
          id: 'Scegli il colore di sfondo per il blocco',
          defaultMessage: 'Scegli il colore di sfondo per il blocco',
        }),
        choices: [
          ['no-background', intl.formatMessage({ id: 'Nessuno sfondo', defaultMessage: 'No background' })],
          ['blue-background', intl.formatMessage({ id: 'Azzurro', defaultMessage: 'Azzurro' })],
          ['pastel-blue-background', intl.formatMessage({ id: 'AzzurroPastello', defaultMessage: 'Azzurro pastello' })],
        ],
        default: 'no-background',
      },
      altezzaMappa: {
        title: intl.formatMessage({ id: 'Altezza mappa', defaultMessage: 'Altezza Mappa' }),
        description: intl.formatMessage({
          id: 'Scegli altezza della mappa',
          defaultMessage: 'Scegli altezza della mappa',
        }),
        choices: [
          ['short-map', intl.formatMessage({ id: 'Piccola', defaultMessage: 'Piccola' })],
          ['medium-map', intl.formatMessage({ id: 'Media', defaultMessage: 'Media' })],
          ['big-map', intl.formatMessage({ id: 'Grande', defaultMessage: 'Grande' })],
        ],
        default: 'medium-map',
      },
      linkText: {
        title: intl.formatMessage({
          id: 'Testo Link',
          defaultMessage: 'Testo Link',
        }),
        description: intl.formatMessage({
          id: 'Testo da visualizzare per il link',
          defaultMessage: 'Testo da visualizzare per il link',
        }),
        type: 'string',
        default: '',
      },
      linkUrl: {
        title: intl.formatMessage({
          id: 'Link a',
          defaultMessage: 'Link a',
        }),
        description: intl.formatMessage({
          id: 'URL di destinazione del link',
          defaultMessage: 'URL di destinazione del link',
        }),
        type: 'string',
        widget: 'url',
      },
      alignButtonRight: {
        title: intl.formatMessage({
          id: 'Allinea bottone a destra',
          defaultMessage: 'Allinea bottone a destra',
        }),
        type: 'boolean',
        default: false,
      },
    },
  };
};

const luogoSchemaEnhancer = (schema, context) => {
  if (!schema.fieldsets.find((f) => f.id === 'indirizzo')) {
    schema.fieldsets.push({
      id: 'indirizzo',
      title: 'Indirizzo',
      fields: [
        'via',
        'cap',
        'citta',
        'provincia',
        'nazione',
      ],
    });

    schema.properties.via = {
      title: 'Via',
      type: 'string',
    };
    schema.properties.cap = {
      title: 'CAP',
      type: 'string',
    };
    schema.properties.citta = {
      title: 'Città',
      type: 'string',
    };
    schema.properties.provincia = {
      title: 'Provincia',
      type: 'string',
    };
    schema.properties.nazione = {
      title: 'Nazione',
      type: 'string',
    };
  }
  return schema;
};

export default function applyConfig(config) {
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    ...blocksConfig,
  };

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Luogo: LuogoView,
    Bando: BandoView,
    listing: {
      ...(config.views.contentTypesViews.listing || {}),
      lista_news: NewsTemplate,
      bandi_card: BandiCardTemplate,
      simple_card: SimpleCardTemplate,
      image_card: ImageCardTemplate,
      mappa_view: MappaTemplate,
      allegati_card: AllegatiTemplate,
      allegati_list: AllegatiListaTemplate,
      linkonlyimage_card: LinkToImageTemplate
    },
  };

  config.views.contentTypesEditViews = {
    ...config.views.contentTypesEditViews,
    Luogo: LuogoEdit,
  };

  config.settings.ssr = {
    ...config.settings.ssr,
    disabledViews: ['Luogo'],
    disabledBlocks: ['localizzazione'],
  };

  config.widgets.widget.color_picker = ColorPickerWidget;

  config.widgets.id = {
    ...config.widgets.id,
    geolocation: GeoLocationWidget,
  };

  // Configurazione delle variations
  config.blocks.blocksConfig.listing.variations = [
    ...(config.blocks.blocksConfig.listing.variations || []),
    {
      id: 'lista_news',
      title: 'Lista News',
      template: NewsTemplate,
      schemaEnhancer: listNewsSchemaEnhancer,
      templateProps: ['data'],
    },
    {
      id: 'bandi_card',
      title: 'Bandi card',
      template: BandiCardTemplate,
      schemaEnhancer: bandiCardSchemaEnhancer,
      templateProps: ['data'],
    },
    {
      id: 'simple_card',
      title: 'Card semplice',
      template: SimpleCardTemplate,
      schemaEnhancer: imageCardSchemaEnhancer,
      templateProps: ['data'],
    },
    {
      id: 'image_card',
      title: 'Card con immagine',
      template: ImageCardTemplate,
      schemaEnhancer: imageCardSchemaEnhancer,
      templateProps: ['data'],
    },
    {
      id: 'mappa_view',
      title: 'Mappa',
      template: MappaTemplate,
      schemaEnhancer: mappaSchemaEnhancer,
      templateProps: ['data'],
    },
    {
      id: 'allegati_card',
      title: 'Allegati card',
      template: AllegatiTemplate,
      schemaEnhancer: allegatiSchemaEnhancer,
      templateProps: ['data'],
    },
    {
      id: 'allegati_list',
      title: 'Allegati lista',
      template: AllegatiListaTemplate,
      schemaEnhancer: allegatiSchemaEnhancer,
      templateProps: ['data'],
    },
    {
      id: 'linkonlyimage_card',
      title: 'Blocco link solo immagine',
      template: LinkToImageTemplate,
      schemaEnhancer: allegatiSchemaEnhancer,
      templateProps: ['data'],
    },
  ];

  config = voltoGdprPrivacy(config);

  config = voltoSocialSettings(config);

  //config.blocks.blocksConfig = {
  //  ...config.blocks.blocksConfig,
  //  defaultSchemaEnhancers: {
  //    ...(config.blocks.blocksConfig.defaultSchemaEnhancers || {}),
  //    Luogo: luogoSchemaEnhancer,
  //  },
  //};

  config.settings.schemaEnhancers = [
    ...(config.settings.schemaEnhancers || []),
    {
      id: 'luogoCustom',
      schema: luogoSchemaEnhancer,
    },
  ];


  config.settings.defaultLanguage = 'it';
  // config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['it'];

  // *** CONFIGURAZIONE MATOMO - AGGIUNGI QUESTA SEZIONE ***
   config.settings.matomoSiteId = 71;
   config.settings.matomoUrlBase = 'https://analytics.comune.parma.it//';     
  // *** FINE CONFIGURAZIONE MATOMO ***


  // Aggiungi il plugin underline in modo più completo
  if (config.settings.richTextEditorSettings) {
    // Aggiungi il plugin underline
    if (!config.settings.richTextEditorSettings.plugins.includes('underline')) {
      config.settings.richTextEditorSettings.plugins.push('underline');
    }

    // Aggiungi il pulsante alla toolbar
    const toolbar = config.settings.richTextEditorSettings.toolbar;
    const formatButtonIndex = toolbar.findIndex(item =>
      Array.isArray(item) && item.includes('bold'));

    if (formatButtonIndex >= 0) {
      // Aggiungi underline accanto agli altri controlli di formattazione
      if (!toolbar[formatButtonIndex].includes('underline')) {
        toolbar[formatButtonIndex].push('underline');
      }
    } else {
      // Altrimenti aggiungi come nuovo gruppo
      toolbar.push(['underline']);
    }

    // Assicurati che il formato underline sia disponibile
    if (!config.settings.richTextEditorSettings.formats) {
      config.settings.richTextEditorSettings.formats = {};
    }

    // Definisci il formato underline se non esiste già
    if (!config.settings.richTextEditorSettings.formats.underline) {
      config.settings.richTextEditorSettings.formats = {
        ...config.settings.richTextEditorSettings.formats,
        underline: { inline: 'span', styles: { textDecoration: 'underline' } }
      };
    }
  }

  // Applica la configurazione Slate per l'underline
  config = slateConfig(config);

  return config;
}